import type { CaptureResult } from "@posthog/types";

/** Minimal browser PostHog surface used outside React hooks. */
export interface PostHogBrowserClient {
  capture: (event: string, properties?: Record<string, unknown>) => void;
  set_config: (config: {
    before_send?: (event: CaptureResult | null) => CaptureResult | null;
  }) => void;
  identify: (id: string, properties?: Record<string, unknown>) => void;
  reset: () => void;
  setPersonPropertiesForFlags: (properties: Record<string, unknown>) => void;
  group: (groupType: string, groupKey: string) => void;
  reloadFeatureFlags: () => void;
  captureException: (error: unknown) => void;
  getFeatureFlagResult: (key: string) => unknown;
}

let browserClient: PostHogBrowserClient | null = null;

export function setBrowserPostHog(client: PostHogBrowserClient): void {
  browserClient = client;
}

export function getBrowserPostHog(): PostHogBrowserClient | null {
  return browserClient;
}
